import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";

const SuspendedSales = (props) => {
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState();
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");

  const handleUnSuspend = (pID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/findbyid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/suspendedlist?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      saleids: pID || selectedSalesCheckboxIds,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  }, []);

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  const columns = [
    {
      name: "Suspended Sale ID",
      selector: "ID",
      sortable: true,
    },
    {
      name: "Date",
      selector: "Saletime",
      sortable: true,
    },
    {
      name: "Type",
      selector: "Type",
      sortable: true,
    },
    {
      name: "Customer",
      selector: "Customername",
      sortable: true,
    },
    {
      name: "Items",
      selector: "Itemname",
      sortable: true,
    },
    {
      name: "Total",
      selector: "Total",
      sortable: true,
    },
    {
      name: "Amount Paid",
      selector: "Paymentamount",
      sortable: true,
    },
    {
      name: "Last Payment Date",
      selector: "Paymentdate",
      sortable: true,
    },
    {
      name: "Amount Due",
      selector: "AmountDue",
      sortable: true,
    },
    {
      name: "Comments",
      selector: "Comment",
      sortable: true,
    },
    {
      name: "Unsuspend",
      width: "150px",
      cell: (row) => (
        <Link to={`/sales/${row.ID}`}>
          <button onClick={handleUnSuspend(row.ID)} className="btn btn-primary">
            Unsuspend
          </button>
        </Link>
      ),
    },
    {
      name: "Sales Receipt",
      width: "150px",
      cell: (row) => (
        <button className="btn btn-primary" to={`/sales-receipt/${row.ID}`}>
          Receipt
        </button>
      ),
    },
    {
      name: "Email Receipt",
      selector: "EmailReceipt",
      sortable: true,
    },
    {
      name: "Delete",
      width: "100px",
      cell: (row) => (
        <Link
          className="confirm-text"
          to="#"
          title="Delete"
          data-bs-toggle="modal"
          data-bs-target="#DeleteConfirmationModal"
          onClick={() => handleDeletePopup(row.ID)}
        >
          <i
            className="fa fa-trash text-red fa-2x"
            data-bs-toggle="tooltip"
            title="Delete"
          ></i>
        </Link>
      ),
    },
  ];

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Suspended Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/sales">Sales List</Link>
                </li>
                <li className="breadcrumb-item active">Suspended Sales List</li>
              </ul>
            </div>
          </div>

          <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Suspended Sales List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
      />
    </>
  );
};

export default SuspendedSales;
